import { XCircle, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface BulkActionBarProps {
	selectedCount: number;
	onRejectAll: () => void;
	onClear: () => void;
	isLoading?: boolean;
}

export function BulkActionBar({
	selectedCount,
	onRejectAll,
	onClear,
	isLoading = false,
}: BulkActionBarProps) {
	if (selectedCount === 0) return null;

	return (
		<div
			className={cn(
				"fixed bottom-0 left-0 right-0 z-50",
				"bg-background border-t shadow-lg",
				"px-6 py-3",
				"flex items-center justify-between",
				"animate-in slide-in-from-bottom-4",
			)}
		>
			<span className="font-medium">
				{selectedCount} {selectedCount === 1 ? "issue" : "issues"} selected
			</span>

			<div className="flex gap-2">
				<Button
					variant="destructive"
					onClick={onRejectAll}
					disabled={isLoading}
					>
						<XCircle className="w-4 h-4 mr-2" />
						Skip selected
					</Button>
				<Button variant="outline" onClick={onClear} disabled={isLoading}>
					<X className="w-4 h-4 mr-2" />
					Clear
				</Button>
			</div>
		</div>
	);
}
